/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
/**
 * Check if a given object implements the UserWalletDto interface.
 */
export function instanceOfUserWalletDto(value) {
    let isInstance = true;
    return isInstance;
}
export function UserWalletDtoFromJSON(json) {
    return UserWalletDtoFromJSONTyped(json, false);
}
export function UserWalletDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'pointsBalance': !exists(json, 'pointsBalance') ? undefined : json['pointsBalance'],
    };
}
export function UserWalletDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'pointsBalance': value.pointsBalance,
    };
}
